import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DatiqInputTextGeoComponent,
    DatiqInputTextGeoValidatorService,
} from './components/datiq-input-text-geo';
import { DatiqAutocompleteModule } from '@dat/datiq-components-pkg/autocomplete';
import {
    DatiqInputErrorTypes,
    DatiqValidatorsRegisterService,
} from '@dat/datiq-components-pkg/utils';

@NgModule({
    imports: [CommonModule, DatiqAutocompleteModule],
    declarations: [DatiqInputTextGeoComponent],
    exports: [DatiqInputTextGeoComponent],
})
export class DatiqInputTextModule {
    constructor(
        private _validatorRegistry: DatiqValidatorsRegisterService,
        private _geo: DatiqInputTextGeoValidatorService
    ) {
        this._validatorRegistry.register(
            DatiqInputErrorTypes.GeoIndeterminate,
            this._geo
        );
    }
}
